import { Autocomplete, TextField, type AutocompleteProps } from '@mui/material';
import { Control, Controller, FieldPathByValue, FieldValues } from 'react-hook-form';

type FormAutocompleteProps<T extends FieldValues, Option> = Omit<
  AutocompleteProps<Option, false, false, false>,
  'onBlur' | 'onChange' | 'renderInput' | 'value'
> & {
  name: FieldPathByValue<T, Option | null | undefined>;
  control: Control<T>;
  label?: string;
  required?: boolean;
  requiredMessage?: string;
};

export function FormAutocomplete<T extends FieldValues, Option>({
  name,
  control,
  label,
  required = false,
  requiredMessage,
  ...props
}: FormAutocompleteProps<T, Option>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required ? requiredMessage || true : false }}
      render={({ field: { ref, value, onChange, ...field }, fieldState }) => (
        <Autocomplete
          {...props}
          {...field}
          value={value ?? null}
          onChange={(_, selectedValue) => onChange(selectedValue ?? undefined)}
          renderInput={(params) => (
            <TextField
              {...params}
              inputRef={ref}
              label={label ?? String(name)}
              required={required}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
      )}
    />
  );
}
